import React from 'react';
export default function Button({ text, disabled, onClick }) {
	return (
		<button
			type="button"
			className={`focus:outline-none text-white 
            ${disabled && 'disabled:opacity-75 cursor-no-drop'} 
            bg-green-700
            focus:ring-4 
            mt-2
            font-medium
            rounded-lg 
            text-sm 
            px-5 
            py-2.5 
            mr-2 
            mb-2 
            dark:bg-green-600 
            dark:hover:bg-green-700 
            dark:focus:ring-green-800`}
			disabled={disabled}
			onClick={onClick}
		>
			{text}
		</button>
	);
}
